import { ReportScreen } from '../reports/ReportScreen';

/** Route glue only: the screen body lives in `screens/reports/` (ticket 12 zone). */
export default function ChessTableScreen(): JSX.Element {
  return <ReportScreen kind="chess-table" />;
}
